export enum CreditorInvoiceDetails {
  GET_INVOICE_DETAILS = "GET_INVOICE_DETAILS",
  GET_INVOICE_DETAILS_SUCCESS = "GET_INVOICE_DETAILS_SUCCESS",
  GET_INVOICE_DETAILS_FAIL = "GET_INVOICE_DETAILS_FAIL",
}
